import { combineReducers } from '@reduxjs/toolkit';
import { entitiesReducer } from "./entities";
import { clientSettingsReducer } from "./clientSettings";
import clientEntriesReducer from "./clientEntries";
import { typesReducer } from "./types";
import referenceDataReducer from "./referenceData";
export const reducers = {
  entities: entitiesReducer,
  types: typesReducer,
  clientSettings: clientSettingsReducer,
  clientEntries: clientEntriesReducer,
  referenceData: referenceDataReducer
};
export const rootReducer = combineReducers(reducers);
export default reducers;